import { Paper, styled } from '@mui/material';


export const TemperatureTabTile = styled(Paper)({
    borderRadius: '10px',
    border: '1px solid rgba(99, 99, 99, 0.20)',
    boxShadow: '4px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    margin: '20px 0px 20px 0px',
});